
import { getProducts } from '../../service/productsService';

export default {
    namespaced: true,
    state: {
           products: []
    },
    mutations: {
        dump(state) {
            console.log(state);
        },
        updateProducts(state, products) {
            state.products = products;
        }
    },
    actions: {
        getProducts: async ({commit, rootGetters}) => {
            let accesstoken = rootGetters["userdata/getAccessToken"];

            getProducts(accesstoken).then((products) => {
              commit('updateProducts', products);
            });
        },
    },
    getters: {
        
        products: state => {
            return state.products;
        }
      }
}